import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { errorMessage, successMessage } from "../../utils/alertMessage";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { addUserLead, getLeadSource, getLeadStatus, getLeadStatusApi, getLeadType, getUserLeadStatus, updateUserLead, userLeadAssign } from "../../services/leads";
import { getLocalProductLevel, getUserData } from "../../utils/localStorage";
import { Calendar } from "primereact/calendar";
import { getBankAccount, getPinCodeData, getProduct, getStateWiseCities, getUser } from "../../services/userMasterUser";
import { Dialog } from "primereact/dialog";

export default function LeadFormOperationTeamCreate() {
  const navigate = useNavigate();
  const { state } = useLocation();


  const rowData = state?.rowData || null;
  const products = state?.listState?.products || [];
  const first = state?.listState?.first || 0;
  const rows = state?.listState?.rows || 20;
  const selectedType = state?.listState?.selectedType || "in process";
  const pagesBoxField = state?.listState?.pagesBoxField || 1;
  const statusMap = state?.listState?.statusMap || {};

  const { userProfileData } = getUserData();

  const { productLevel } = getLocalProductLevel();

  const [stateCitiesList, setStateCitiesList] = useState([])

  const [leadTypeList, setLeadTypeList] = useState([])
  const [bankDetailsList, setBankDetailsList] = useState([])

  const [typeOfLead, setTypeOfLead] = useState(rowData?.lead?.id ? rowData?.lead?.typeOfLead : "Loan");
  const [leadStatusList, setLeadStatusList] = useState([]);
  const [leadSourceList, setLeadSourceList] = useState([]);
  const [productsList, setProductsList] = useState([]);
  const [stateCityList, setStateCityList] = useState({});

  const [userLeadStatus, setUserLeadStatus] = useState([])
  const [selectedUserLeadStatus, setSelectedUserLeadStatus] = useState(rowData?.lead?.id ? rowData?.status : "WORKING");
  const selectedAssignToOtherLeadStatus =
    [
      { label: "ASSIGN_TO_OTHER", value: "ASSIGN_TO_OTHER" },
      { label: "DONE", value: "DONE" },
    ]

  const [displayLeadAssignmentUpload, setDisplayLeadAssignmentUpload] = useState(false);
  const [assignedTelecallerId, setAssignedTelecallerId] = useState("")
  const [assignedLeadId, setAssignedLeadId] = useState("")

  const [leadStatusdata, setLeadStatusdata] = useState([])

  const [userDataIds, setUserDataIds] = useState([]);

  const onClickLeadAssignmentUpload = (item) => {
    setAssignedLeadId(item)
    setDisplayLeadAssignmentUpload(true);
  };
  const onHideLeadAssignmentUpload = () => {

    setAssignedTelecallerId("");
    setDisplayLeadAssignmentUpload(false);
  };


  let today = new Date();
  let month = today.getMonth();
  let year = today.getFullYear();
  let prevMonth = month === 0 ? 11 : month - 1;
  let prevYear = prevMonth === 11 ? year - 1 : year;
  // let nextMonth = month === 11 ? 0 : month + 1;
  // let nextYear = nextMonth === 0 ? year + 1 : year;
  let nextYear = year + 10;

  let minDate = new Date();

  // minDate.setMonth(prevMonth);
  // minDate.setFullYear(prevYear);

  let maxDate = new Date();

  // maxDate.setMonth(nextMonth);
  maxDate.setFullYear(nextYear);


  const typeOfLeadList = [
    { label: "Loan Type Lead", value: "loan_type_lead" },
    { label: "Project Report, Tev Study Pitch Deck", value: "project_report_tev_study_pitch_deck" },
    { label: "Subsidy", value: "subsidy" },
  ];

  const statusOfBusinessList = [
    { label: "New", value: "New" },
    { label: "Existing", value: "Existing" },
  ];

  const TypeOfCustomerData = [
    { label: "Salaried", value: "Salaried" },
    { label: "Self Employed", value: "Self Employed" },
    { label: "Business Partner", value: "Business Partner" },
  ];

  const TypeOfCustomerData2 = [
    { label: "Self Employed", value: "Self Employed" },
    { label: "Business Partner", value: "Business Partner" },
  ];

  const LevelOfCustomerData = [
    { label: "High Profile", value: "High Profile" },
    { label: "Medium Profile", value: "Medium Profile" },
    { label: "Low Profile", value: "Low Profile" },
  ];

  // const ActionOnLeadData = [
  //   { label: "In Process", value: "In Process" },
  //   { label: "Prelogin", value: "Prelogin" },
  //   { label: "Hold For Follow Up After Sometime", value: "Hold For Follow Up After Sometime" },
  //   { label: "Call Not Pick Up", value: "Call Not Pick Up" },
  //   { label: "Not Interested", value: "Not Interested" },
  //   { label: "Not Doable", value: "Not Doable" },
  // ];

  // const ActionOnLeadOperationData = [
  //   { label: "Login", value: "Login" },
  //   { label: "Sanction", value: "Sanction" },
  //   { label: "Disbursement", value: "Disbursement" },
  //   { label: "Decline", value: "Decline" },
  //   { label: "Hold By Customer", value: "Hold By Customer" },
  // ];

  // const ActionOnLeadData2 = [
  //   { label: "In Process", value: "In Process" },
  //   { label: "Work Assign To Operation", value: "Work Assign To Operation" },
  //   { label: "Work Include", value: "Work Include" },
  //   { label: "Hold For Follow Up After Sometime", value: "Hold For Follow Up After Sometime" },
  //   { label: "Call Not Pick Up", value: "Call Not Pick Up" },
  //   { label: "Not Interested", value: "Not Interested" },
  //   { label: "Not Doable", value: "Not Doable" },
  // ];

  const TelecallerActionData = [
    { label: "In Process", value: "In Process" },
    { label: "Not Interested", value: "Not Interested" },
    { label: "Call Not Pick Up", value: "Call Not Pick Up" },
    { label: "Success", value: "Success" },
  ];

  const DPRTeamData = [
    { label: "In Process", value: "In Process" },
    { label: "Complete", value: "Complete" },
  ];

  const CMATeamData = [
    { label: "In Process", value: "In Process" },
    { label: "Complete", value: "Complete" },
  ];

  const paymentStatus = [
    { label: "Recorded", value: "Recorded" },
    { label: "Not Recorded", value: "Not Recorded" },
  ]

  const cibilScoreListData = [
    { label: "Low (Below 600)", value: "Low (Below 600)" },
    { label: "Average (600 - 699)", value: "Average (600 - 699)" },
    { label: "Medium (700 - 749)", value: "Medium (700 - 749)" },
    { label: "Excellent (Above 750)", value: "Excellent (Above 750)" },
    { label: "I Don't Know", value: "I Don't Know" },
  ]



  // Common Fields
  const [commonInput, setCommonInput] = useState({
    name: rowData?.lead?.name || "",
    mobileNo: rowData?.lead?.mobileNo || "",
    source: rowData?.lead?.source || "",
    city: rowData?.lead?.city || "",
    pinCode: rowData?.lead?.pinCode || "",
    state: rowData?.lead?.state || "",
    address: rowData?.lead?.address || "",
    loanAmount: rowData?.lead?.amount || "",
    remarkCustomer: rowData?.lead?.queries || "",
    productId: rowData?.lead?.productId || "",
    productInfo: rowData?.lead?.productInfo || "",
    status: rowData?.lead?.status || ""
  });

  const citiesList = stateCityList[commonInput.state] || [];

   const apiKey = process.env.REACT_APP_GOOGLE_API_KEY;
  
    useEffect(() => {
      const fetchProductLevel = async (pinCode) => {
        try {
          const response = await getPinCodeData(pinCode, apiKey);
  
          const data = response.data;
  
          if (data.status === "OK") {
            const components = data.results[0]?.address_components || [];
  
            let city = "";
            let state = "";
  
            components.forEach((component) => {
              if (component.types.includes("locality")) {
                city = component.long_name;
              }
  
              if (
                component.types.includes("administrative_area_level_1")
              ) {
                state = component.long_name;
              }
            });
  
            // IMPORTANT: use setter
            setCommonInput((prev) => ({
              ...prev,
              city,
              state,
            }));
          }
        } catch (err) {
          console.error("Error fetching pincode data:", err);
        }
      };
  
      if (commonInput?.pinCode?.length === 6) {
        fetchProductLevel(commonInput.pinCode);
      }
    }, [commonInput.pinCode, apiKey]);

  // Dynamic Fields
  const [leadDetails, setLeadDetails] = useState({});
  const [errors, setErrors] = useState({});

  // Dynamic Field Config
  const leadTypeFields = {
    loan_type_lead: [
      { name: "actionOnLead", label: "Action On Lead", type: "dropdown", options: leadStatusdata },
      { name: "emailId", label: "Email Id", type: "text"},
      { name: "natureOfBusienss", label: "Nature Of Busienss - Existing/ Proposed", type: "text",},
      { name: "sales", label: "Sales - Existing/ Proposed", type: "number"},
      { name: "statusOfBusiness", label: "Status Of Business", type: "dropdown", options: statusOfBusinessList},
      { name: "remarkTelecaller", label: "Remark Telecaller", type: "text" },
      { name: "whatIsYourCibilScore", label: "What Is Your Cibil Score", type: "dropdown", options: cibilScoreListData},
      { name: "typeOfCustomer", label: "Type Of Customer", type: "dropdown", options: TypeOfCustomerData},
      { name: "levelOfCustomer", label: "Level Of Customer", type: "dropdown", options: LevelOfCustomerData},
      {
        name: "nextFollowUpDate", label: "Next Follow Up Date", type: "date", hideWhen: {
          field: "actionOnLead",
          values: ["decline",] // ✅ multiple values
        }
      },
      { name: "typeOfLoanProduct", label: "Type Of Loan Product", type: "text"
       },
      { name: "nameOfBank", label: "Name Of Bank", type: "text",
       },
      { name: "remark", label: "Remark", type: "text" },
      
      // 👇 Conditional Fields
      {
        name: "dateOfSanction",
        label: "Date Of Sanction",
        type: "date",
        showWhen: { field: "actionOnLead", value: "sanction" },
      },
      {
        name: "dateOfDisbursement",
        label: "Date Of Disbursement",
        type: "date",
        showWhen: { field: "actionOnLead", value: "disbursement" },
      },
      {
        name: "reasonForRejection",
        label: "Reason For Rejection",
        type: "text",
        showWhen: { field: "actionOnLead", value: "decline" },
      },
    ],

    project_report_tev_study_pitch_deck: [
      { name: "actionOnLead", label: "Action On Lead", type: "dropdown", options: leadStatusdata },
      {
        name: "emailId", label: "Email Id", type: "text"},
      { name: "natureOfBusienssForProjectReport", label: "Nature Of Busienss For Project Report", type: "text"},
      { name: "remarkByTelecaller", label: "Remark By Telecaller", type: "text" },
      { name: "typeOfCustomer", label: "Type Of Customer", type: "dropdown", options: TypeOfCustomerData2,
        
       },
      { name: "levelOfCustomer/BusinessPartner", label: "Level Of Customer/ Business Partner", type: "dropdown", options: LevelOfCustomerData,
        
       },
      {
        name: "nextFollowUpDate", label: "Next Follow Up Date", type: "date", hideWhen: {
          field: "actionOnLead",
          values: ["decline"] // ✅ multiple values
        } },
      {
        name: "totalFeesAgreed", label: "Total Fees Agreed", type: "number",  },
      {
        name: "advance", label: "Advance", type: "number",  },
      {
        name: "advanceReceivedDate", label: "Advance Received Date", type: "date",  },
      {
        name: "bankDetail", label: "Bank Detail", type: "dropdown", options: bankDetailsList,   },
      {
        name: "commitmentDate", label: "Commitment Date", type: "date",  },
      {
        name: "finalDue", label: "Final Due", type: "number",  },
      {
        name: "finalAmountRecdDate", label: "Final Amount Recd Date", type: "date", },
      {
        name: "bankAccount", label: "Bank Account", type: "number", },

      {
        name: "dprTeam1,2", label: "DPR Team 1,2", type: "dropdown", options: DPRTeamData,  },
      {
        name: "cmaTeam1,2", label: "CMA Team 1,2", type: "dropdown", options: CMATeamData,  },
      // { name: "reasonForRejection", label: "Reason For Rejection", type: "text" },
      {
        name: "reasonForRejection",
        label: "Reason For Rejection",
        type: "text",
        showWhen: { field: "actionOnLead", value: "decline" },
      },

    ],

    subsidy: [
      { name: "emailId", label: "Email Id", type: "text" },
      { name: "remarkTelecaller", label: "Remark Telecaller", type: "text" },
      { name: "telecallerAction", label: "Telecaller Action", type: "dropdown", options: TelecallerActionData },
      { name: "nextFollowUpDate", label: "Next Follow Up Date", type: "date" },
      { name: "advancePaymentStatus", label: "Advance Payment Status", type: "dropdown", options: paymentStatus },
      { name: "dateOfPayment1", label: "Date Of Payment", type: "date" },
      { name: "bankDetail1", label: "Bank Detail", type: "text" },
      { name: "finalPaymentStatus", label: "Final Payment Status", type: "dropdown", options: paymentStatus },
      { name: "dateOfPayment2", label: "Date Of Payment", type: "date" },
      { name: "bankDetail2", label: "Bank Detail", type: "text" },
      { name: "reasonForRejection", label: "Reason For Rejection", type: "text" },
    ],
  };

  // Reset dynamic fields when type changes
  useEffect(() => {
    setLeadDetails({});
    setErrors({});
    const leadStatusApiData = {
      leadTypeIn: [typeOfLead],
      roleIn: [userProfileData.role],
      statusIn: [],
      activeOnly: "yes"
    };

    fetchLeadStatusApiData(leadStatusApiData)
  }, [typeOfLead]);


  const fetchLeadStatusApiData = (data) => {

    getLeadStatusApi(data)
      .then((response) => {
        if (!response.data.error) {
          const newData = response.data.data || response.data; // adjust if API structure differs

          const newLeadStatusData = newData.map(item => ({
            label: item.trim(), value: item.trim()
          }));
          setLeadStatusdata(newLeadStatusData);
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch(() => {
        errorMessage();
      })
  };

  const userData = {
    searchBy: "",
    searchText: "",
    limit: 1000,
    offset: 0,
    sortBy: "",
    sortOrder: "desc",
    userTypeIdIn: [],
    roleIn: ["ROLE_OPERATION"],
    statusIn: ["ACTIVE"]
  };

  const getUsers = (userData) => {
    getUser(userData)
      .then((response) => {
        if (!response.data.error) {
          const newData = response.data.data || response.data; // adjust if API structure differs
          const newDataId = newData.map(item => item.id);
          const newDataIds = newData.map(item => ({
            label: item.userName + " - " + item?.userTypeInfo, value: item.id
          }));

          setUserDataIds(newDataIds)
        }
      })
      .catch(() => {
        errorMessage();
      })
  }



  const fetchUserLeadStatus = () => {

    getUserLeadStatus()
      .then((response) => {
        if (!response.data.error) {

          const rawData = response.data.data || response.data;
          const filterData = rawData.filter(item => item !== "ASSIGN_TO_OTHER")
          const newDataIds = filterData.map(item => ({
            label: item, value: item
          }));
          setUserLeadStatus(newDataIds)
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch(() => {
        errorMessage();
      })
  };

const removeCountryCode = (mobile = "") =>
    mobile.replace(/^\+?91\s*/, "").trim();
  
  useEffect(() => {

    setCommonInput((prev) => ({
      ...prev,
      mobileNo: removeCountryCode(rowData?.lead?.mobileNo),
    }));
    
    getUsers(userData)
    fetchUserLeadStatus()

    if (rowData?.leadInfoList && rowData?.leadInfoList.length > 0) {

      let dynamicData = {};

      rowData.leadInfoList.forEach((item) => {

        if (item.keyType === "textType") {
          dynamicData[item.keyName] = item.textValue;
        }

        if (item.keyType === "doubleType") {
          dynamicData[item.keyName] = item.doubleValue;
        }

        if (item.keyType === "dateType") {
          dynamicData[item.keyName] = item.dateValue ? new Date(item.dateValue) : null;
        }

        if (commonInput.status) {
          dynamicData["actionOnLead"] = commonInput.status ? commonInput.status : null;
        }

      });

      setLeadDetails(dynamicData);
    }
  }, [state]);

  // Fetch dropdown data
  useEffect(() => {

    const productDataApi = {
      searchBy: "",
      searchText: "",
      limit: 100000,
      offset: 0,
      sortBy: "",
      sortOrder: "desc",
      statusIn: [],
      idIn: productLevel.map((item) => item.productId)
    };


    getProduct(productDataApi)
      .then((response) => {
        if (!response.data.error) {
          const newData = response.data.data || response.data; // adjust if API structure differs
          const leadStatus = newData.map((item) => ({
            label: item.name,
            value: item.id,
            amount: item.amount,
          }));
          setProductsList(leadStatus);
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch(() => {
        errorMessage();
      })

    getLeadType()
      .then((response) => {
        if (!response.data.error) {
          const leadStatus = response.data.map((item) => ({
            label: item,
            value: item,
          }));
          setLeadTypeList(leadStatus);
        }
      })
      .catch(() => errorMessage());

    // getLeadStatus()
    //   .then((response) => {
    //     if (!response.data.error) {
    //       const leadStatus = response.data.map((item) => ({
    //         label: item,
    //         value: item,
    //       }));
    //       setLeadStatusList(leadStatus);
    //     }
    //   })
    //   .catch(() => errorMessage());

    getLeadSource()
      .then((response) => {
        if (!response.data.error) {
          const leadSource = response.data.map((item) => ({
            label: item,
            value: item,
          }));
          setLeadSourceList(leadSource);
        }
      })
      .catch(() => errorMessage());


    getBankAccount()
      .then((response) => {
        if (!response.data.error) {
          const leadSource = response.data.map((item) => ({
            label: item.name,
            value: item.name,
          }));
          setBankDetailsList(leadSource)
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch(() => {
        errorMessage();
      })

    const stateCitiesData = {
      searchBy: "",
      searchText: "",
      limit: 100000,
      offset: 0,
      sortBy: "",
      sortOrder: "desc",
      cityIn: [],
      stateIn: []
    }

    getStateWiseCities(stateCitiesData)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;

          // const stateList = Object.keys(Res).map((key) => ({
          //   key
          // }));

          const stateListArray = Object.keys(Res);

          const stateList = stateListArray.map((item) => ({
            label: item,
            value: item,
          }));

          setStateCitiesList(stateList)

          setStateCityList(Res)
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch((err) => {
        errorMessage();
      })
      .finally(() => console.log(false));
  }, []);

  useEffect(() => {
    if (commonInput?.productId) {
      const selectedProduct = productsList.find(
        (item) => item.value === commonInput.productId
      );

      if (selectedProduct) {
        setLeadDetails((prev) => ({
          ...prev,
          totalFeesAgreed: selectedProduct.amount,
        }));
      }
    }
  }, [commonInput?.productId, productsList]);

  const totalFeesAgreed = Number(leadDetails.totalFeesAgreed) || 0;
  const advance = Number(leadDetails.advance) || 0;

  leadDetails.finalDue = totalFeesAgreed - advance;

  const isFieldVisible = (field) => {
    if (field.hideWhen) {
      const dependentValue = leadDetails[field.hideWhen.field];
      const values = field.hideWhen.values || [field.hideWhen.value];

      if (values.includes(dependentValue)) {
        return false;
      }
    }

    if (field.showWhen) {
      const dependentValue = leadDetails[field.showWhen.field];

      if (dependentValue !== field.showWhen.value) {
        return false;
      }
    }

    return true;
  };

  const validateForm = () => {
    let isValid = true;
    let newErrors = {};

    if (!typeOfLead) {
      newErrors.typeOfLead = "Please Select Type Of Lead";
      isValid = false;
    }

    if (!commonInput.name) {
      newErrors.name = "Please Enter Name";
      isValid = false;
    }

    if (!commonInput.mobileNo) {
      newErrors.mobileNo = "Please Enter Mobile No";
      isValid = false;
    }

    if (!commonInput.source) {
      newErrors.source = "Please Enter Source";
      isValid = false;
    }


    if (!commonInput.loanAmount) {
      newErrors.loanAmount = "Please Enter Amount";
      isValid = false;
    }

    if (!commonInput.city) {
      newErrors.city = "Please Enter City";
      isValid = false;
    }

    if (!commonInput.pinCode) {
      newErrors.pinCode = "Please Enter Pin Code";
      isValid = false;
    }

    if (!commonInput.state) {
      newErrors.state = "Please Enter State";
      isValid = false;
    }

    if (!commonInput.address) {
      newErrors.address = "Please Enter Address";
      isValid = false;
    }

    if (!commonInput.productId) {
      newErrors.productId = "Please Select Product";
      isValid = false;
    }


     
    if (typeOfLead === "Loan" && !commonInput.status) {
      newErrors.status = "Please Select Status";
      isValid = false;
    }

    leadTypeFields[typeOfLead]?.forEach((field) => {
      if (!isFieldVisible(field)) return;

      if (!leadDetails[field.name]) {
        newErrors[field.name] = `Please Enter ${field.label}`;
        isValid = false;
      }
    });

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!validateForm()) return;

    let leadInfoList = [];

    // Loop dynamic fields based on selected lead type
    leadTypeFields[typeOfLead]?.forEach((field) => {

      // Skip hidden conditional fields
      if (field.showWhen) {
        const dependentValue = leadDetails[field.showWhen.field];
        if (dependentValue !== field.showWhen.value) return;
      }

      const value = leadDetails[field.name];

      if (value === undefined || value === null || value === "") return;

      let leadInfoObj = {
        keyType: "",
        keyName: field.name,
        textValue: "",
        doubleValue: "",
        dateValue: ""
      };

      // Map field type to correct value column
      if (field.type === "text" || field.type === "dropdown") {
        leadInfoObj.keyType = "textType";
        leadInfoObj.textValue = value;
      }

      if (field.type === "number") {
        leadInfoObj.keyType = "doubleType";
        leadInfoObj.doubleValue = Number(value);
      }

      if (field.type === "date") {
        leadInfoObj.keyType = "dateType";
        leadInfoObj.dateValue = value;
      }

      leadInfoList.push(leadInfoObj);
    });

    const payload = {
      typeOfLead,
      ...commonInput,
      leadInfoList,
    };

    const actionOnLeadStatusValue = leadInfoList.filter((item) => item.keyName === "actionOnLead")

    let UserData = {
      lead: {
        mobileNo: commonInput.mobileNo,
        name: commonInput.name,
        status: typeOfLead === "Loan" ? commonInput.status : actionOnLeadStatusValue[0]?.textValue,
        source: commonInput.source,
        city: commonInput.city,
        pinCode: commonInput.pinCode,
        state: commonInput.state,
        queries: commonInput.remarkCustomer,
        address: commonInput.address,
        amount: commonInput.loanAmount,
        typeOfLead: typeOfLead,
        productId: commonInput.productId,
        productInfo: commonInput.productInfo,
      },
      leadInfoList: leadInfoList.filter((item) => item.keyName !== "actionOnLead"),
      user: {
        id: userProfileData.id
      }

    };

    let UpdateUserData = {
      lead: {
        id: rowData?.lead?.id,
        mobileNo: commonInput.mobileNo,
        name: commonInput.name,
        status: typeOfLead === "Loan" ? commonInput.status : actionOnLeadStatusValue[0]?.textValue,
        source: commonInput.source,
        queries: commonInput.remarkCustomer,
        city: commonInput.city,
        pinCode: commonInput.pinCode,
        state: commonInput.state,
        address: commonInput.address,
        amount: commonInput.loanAmount,
        typeOfLead: typeOfLead,
        productId: commonInput.productId,
        productInfo: commonInput.productInfo,
        dateOfLead: rowData?.lead?.createdDate
      },
      leadInfoList: leadInfoList.filter((item) => item.keyName !== "actionOnLead"),
      user: {
        id: userProfileData.id
      },

    };


    if (rowData?.lead?.id) {

      updateUserLead(UpdateUserData)
        .then((response) => {
          if (!response.data.error) {
            if (response.data.success === false) {
              errorMessage(response.data.message);
            } else {
              successMessage(response.data.message);
              navigate("/operation-lead/list", {
                state: {
                  listState: {
                    products,
                    first,
                    rows,
                    selectedType,
                    pagesBoxField,
                    statusMap
                  }
                }
              })
            }
          } else {
            // errorMessage(response.data.errors.errors[0].message);
          }
        })
        .catch((err) => {
          errorMessage();
        })
    } else {
      addUserLead(UserData)
        .then((response) => {
          if (!response.data.error) {
            if (response.data.success === false) {
              errorMessage(response.data.message);
            } else {
              successMessage(response.data.message);
              navigate("/operation-lead/list", {
                state: {
                  listState: {
                    products,
                    first,
                    rows,
                    selectedType,
                    pagesBoxField,
                    statusMap
                  }
                }
              })
            }
          } else {
            // errorMessage(response.data.errors.errors[0].message);
          }
        })
        .catch((err) => {
          errorMessage();
        })
    }

  };

  const handleLeadAssignmentUpload = (event) => {

    event.preventDefault();

    const leadAssignedData = {
      lead: {
        id: assignedLeadId?.lead?.id
      },
      user: {
        id: assignedTelecallerId
      },
      status: "ASSIGN_TO_OTHER",
    }



    userLeadAssign(leadAssignedData)
      .then((response) => {
        const Res = response.data;
        // handle the response
        if (Res.status === true) {
          successMessage("Lead Assigned Successfully " + Res.message);
          setAssignedTelecallerId("")
          setAssignedLeadId("")
          navigate("/operation-lead/list", {
            state: {
              listState: {
                products,
                first,
                rows,
                selectedType,
                pagesBoxField,
                statusMap
              }
            }
          })

          setDisplayLeadAssignmentUpload(false);
        } else {
          errorMessage("Lead Assigned Failed " + Res.message);
          setAssignedTelecallerId("")
          setAssignedLeadId("")
          navigate("/operation-lead/list", {
            state: {
              listState: {
                products,
                first,
                rows,
                selectedType,
                pagesBoxField,
                statusMap
              }
            }
          })

          setDisplayLeadAssignmentUpload(false);
        }
      })
      .catch((error) => {
        // handle errors
        errorMessage("Lead Assigned Failed");
        setAssignedTelecallerId("")
        setAssignedLeadId("")
        navigate("/operation-lead/list", {
          state: {
            listState: {
              products,
              first,
              rows,
              selectedType,
              pagesBoxField,
              statusMap
            }
          }
        })
        setDisplayLeadAssignmentUpload(false);
      });
  };

  const renderDialogLeadAssignmentUpload = () => (
    <Dialog
      header="Lead Assignment"
      visible={displayLeadAssignmentUpload}
      onHide={() => onHideLeadAssignmentUpload()}
      breakpoints={{ "960px": "75vw" }}
      style={{ width: "50vw" }}
    >
      <div>
        <form onSubmit={handleLeadAssignmentUpload}>
          <div className="row mb-1">
            <h6> {assignedLeadId?.lead?.name} Lead Assigned To </h6>
            <div
              className="col-md-12"
              style={{ display: "flex", justifyContent: "space-between" }}
            >

              <div className="col-md mb-2">
                <Dropdown
                  style={{ width: "100%" }}
                  options={userDataIds}
                  value={assignedTelecallerId}
                  onChange={(e) => {
                    setAssignedTelecallerId(e.value);
                  }}
                />
              </div>
            </div>
          </div>
          {assignedTelecallerId && (
            !["ASSIGN_TO_OTHER", "DONE"].includes(rowData?.status) &&
            <div className="col-md-12 text-center">
              <button
                type="submit"
                className="move-btn move-btn-blue"
              >
                Submit
              </button>
            </div>
          )}
        </form>
      </div>
    </Dialog>
  );


  return (
    <main id="main" className="main">
      <section className="section">
        <div className="card">
          <div className="card-body">
            <h5 className="card-title flex">
              <div
                className="mr-3 cursor-pointer"
                onClick={() =>
                  navigate("/operation-lead/list", {
                    state: {
                      listState: {
                        products,
                        first,
                        rows,
                        selectedType,
                        pagesBoxField,
                        statusMap
                      }
                    }
                  })
                }
              >
                <i class="bi bi-arrow-left-circle-fill"></i>
              </div>
              Lead Form {state ? "Update" : "Create"}
            </h5>

            {state && <div className="row">
              <div className="col-md">

                <div
                  onClick={() =>
                    onClickLeadAssignmentUpload(
                      rowData
                    )
                  }
                  className="move-btn move-btn-yellow center-text cursor-pointer"
                >
                  Assign <i className="bi bi-fast-forward-btn-fill"></i>
                </div>
              </div>
            </div>}

            <form onSubmit={handleSubmit}>

              {/* Type Of Lead */}
              <div className="row mb-1">
                <div className="col-md-6">
                  <label className="form-label">Type Of Lead</label>
                  <Dropdown
                    style={{ width: "100%" }}
                    options={leadTypeList}
                    value={typeOfLead}
                    onChange={(e) => setTypeOfLead(e.value)}
                    // disabled={state ? true : false}
                  />
                  <div className="text-danger">{errors.typeOfLead}</div>
                </div>
                <div className="col-md-6">
                  <label htmlFor="source" className="form-label">
                    Source
                  </label>
                  <Dropdown
                    style={{ width: "100%" }}
                    options={leadSourceList}
                    value={commonInput.source}
                    onChange={(e) => {
                      setCommonInput({ ...commonInput, source: e.target.value })
                    }}
                  />
                  <div className="text-danger">{errors.source}</div>
                </div>
              </div>

              {/* Common Fields */}
              <div className="row mb-1">
                <div className="col-md-6">
                  <label className="form-label">Name</label>
                  <InputText
                    style={{ width: "100%" }}
                    value={commonInput.name}
                    onChange={(e) =>
                      setCommonInput({ ...commonInput, name: e.target.value })
                    }
                  />
                  <div className="text-danger">{errors.name}</div>
                </div>

                <div className="col-md-6">
                  <label className="form-label">Mobile No</label>
                  <InputText
                    type="number"
                    style={{ width: "100%" }}
                    value={commonInput.mobileNo}
                    onChange={(e) =>
                      setCommonInput({ ...commonInput, mobileNo: e.target.value })
                    }
                  />
                  <div className="text-danger">{errors.mobileNo}</div>
                </div>
              </div>

              <div className="row mb-1">
                <div className="col-md-6">
                  <label className="form-label">Amount {typeOfLead === "project_report_tev_study_pitch_deck" ? "(Project Cost)" : ""}</label>
                  <InputText
                    type="text"
                    style={{ width: "100%" }}
                    value={
                      commonInput.loanAmount
                        ? Number(commonInput.loanAmount).toLocaleString("en-IN")
                        : ""
                    }
                    onChange={(e) => {
                      // Remove commas and allow only digits
                      const value = e.target.value.replace(/,/g, "").replace(/\D/g, "");

                      setCommonInput({
                        ...commonInput,
                        loanAmount: value, // Store raw value
                      });
                    }}
                  />
                  <div className="text-danger">{errors.loanAmount}</div>
                </div>

                <div className="col-md-6">
                  <label className="form-label">Pin Code </label>
                  <InputText
                    type="number"
                    style={{ width: "100%" }}
                    value={commonInput.pinCode}
                    onChange={(e) =>
                      setCommonInput({ ...commonInput, pinCode: e.target.value })
                    }
                    onWheel={(e) => e.target.blur()} // prevent mouse scroll
                    onKeyDown={(e) => {
                      if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                        e.preventDefault(); // prevent arrow increment/decrement
                      }
                    }}
                  />
                  <div className="text-danger">{errors.pinCode}</div>
                </div>
                
              </div>
              <div className="row mb-1">
                <div className="col-md-6">
                  <label className="form-label">State</label>
                  {/*<Dropdown
                    style={{ width: "100%" }}
                    value={commonInput.state}
                    onChange={(e) =>
                      setCommonInput({ ...commonInput, state: e.target.value })
                    }
                    options={stateCitiesList}
                    optionLabel="label"
                    placeholder="Select a State"
                    filter
                    filterDelay={400}
                  />*/}
                  <InputText
                    style={{ width: "100%" }}
                    value={commonInput.state}
                    onChange={(e) =>
                      setCommonInput({ ...commonInput, state: e.target.value })
                    }
                    onWheel={(e) => e.target.blur()} // prevent mouse scroll
                    onKeyDown={(e) => {
                      if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                        e.preventDefault(); // prevent arrow increment/decrement
                      }
                    }}
                  />
                  <div className="text-danger">{errors.state}</div>
                </div>

                <div className="col-md-6">
                  <label className="form-label">City</label>
                  {/*<Dropdown
                    style={{ width: "100%" }}
                    value={commonInput.city}
                    onChange={(e) =>
                      setCommonInput({ ...commonInput, city: e.target.value })
                    }
                    options={citiesList}

                    placeholder="Select a City"
                    filter
                    filterDelay={400}
                  />*/}
                  <InputText
                      style={{ width: "100%" }}
                      value={commonInput.city}
                      onChange={(e) =>
                        setCommonInput({ ...commonInput, city: e.target.value })
                      }
                      onWheel={(e) => e.target.blur()} // prevent mouse scroll
                      onKeyDown={(e) => {
                        if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                          e.preventDefault(); // prevent arrow increment/decrement
                        }
                      }}
                    />
                  <div className="text-danger">{errors.city}</div>
                </div>
              </div>
              <div className="row mb-1">

                <div className="col-md-6">
                  <label className="form-label">Address</label>
                  <InputText
                    style={{ width: "100%" }}
                    value={commonInput.address}
                    onChange={(e) =>
                      setCommonInput({ ...commonInput, address: e.target.value })
                    }
                  />
                  <div className="text-danger">{errors.address}</div>
                </div>
                <div className="col-md-6">
                  <label className="form-label">Remark Customer</label>
                  <InputText
                    style={{ width: "100%" }}
                    value={commonInput.remarkCustomer}
                    onChange={(e) =>
                      setCommonInput({ ...commonInput, remarkCustomer: e.target.value })
                    }
                  />
                  <div className="text-danger">{errors.remarkCustomer}</div>
                </div>
              </div>

              <div className="row mb-1">

                <div className="col-md-6">
                  <label className="form-label" htmlFor="productId" >
                    Product
                  </label>
                  <Dropdown
                    style={{ width: "100%" }}
                    options={productsList}
                    value={commonInput.productId}
                    onChange={(e) => {
                      setCommonInput({ ...commonInput, productId: e.target.value })
                    }}
                  />
                  <div className="text-danger">{errors.productId}</div>
                </div>
                {commonInput?.productId && <div className="col-md-6">
                  <label className="form-label" htmlFor="productInfo" >
                    Product Info
                  </label>
                  <InputText
                    style={{ width: "100%" }}
                    value={commonInput.productInfo}
                    // onChange={(e) =>
                    //   setCommonInput({ ...commonInput, productInfo: e.target.value })
                    // }
                    readOnly
                  />
                </div>}
              </div>
              <div className="row mb-1">
                { typeOfLead === "Loan" && <div className="col-md-6">
                  <label htmlFor="status" className="form-label">
                      Action On Lead
                    </label>
                    <Dropdown
                      style={{ width: "100%" }}
                      options={leadStatusdata}
                      value={commonInput.status}
                      onChange={(e) => {
                        setCommonInput({ ...commonInput, status: e.target.value })
                      }}
                    />
                    <div className="text-danger">{errors.status}</div>
                  </div>}
              </div>

              {/* Dynamic Fields */}

              <div className="row">
                {leadTypeFields[typeOfLead]?.map((field, index) => {


                  // ✅ HIDE CONDITION
                  if (field.hideWhen) {
                    const dependentValue = leadDetails[field.hideWhen.field];

                    const values = field.hideWhen.values || [field.hideWhen.value];

                    if (values.includes(dependentValue)) {
                      return null;
                    }
                  }

                  // ✅ CONDITIONAL SHOW LOGIC
                  if (field.showWhen) {
                    const dependentValue = leadDetails[field.showWhen.field];
                    if (dependentValue !== field.showWhen.value) {
                      return null;
                    }
                  }

                  return (
                    <div className="col-md-6 mb-1" key={index}>
                      <label className="form-label">{field.label}</label>

                      {field.type === "text" && (
                        <InputText
                          style={{ width: "100%" }}
                          value={leadDetails[field.name] || ""}
                          onChange={(e) =>
                            setLeadDetails({
                              ...leadDetails,
                              [field.name]: e.target.value,
                            })
                          }
                        />
                      )}

                      {field.type === "number" && (
                        <InputText
                          type="number"
                          style={{ width: "100%" }}
                          value={leadDetails[field.name] || ""}
                          onChange={(e) =>
                            setLeadDetails({
                              ...leadDetails,
                              [field.name]: e.target.value,
                            })
                          }
                          onWheel={(e) => e.target.blur()} // prevent mouse scroll
                          onKeyDown={(e) => {
                            if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                              e.preventDefault(); // prevent arrow increment/decrement
                            }
                          }}
                        />
                      )}

                      {field.type === "date" && (
                        <div>
                          <Calendar id="buttondisplay"
                            value={leadDetails[field.name] || null}
                            onChange={(e) => setLeadDetails({
                              ...leadDetails,
                              [field.name]: e.target.value,
                            })}
                            showIcon
                            dateFormat="dd/mm/yy"
                            minDate={minDate}
                            maxDate={maxDate}
                            style={{ width: "100%" }}
                          />
                        </div>
                      )}

                      {field.type === "dropdown" && (
                        <Dropdown
                          style={{ width: "100%" }}
                          options={field.options}
                          value={leadDetails[field.name] || ""}
                          onChange={(e) =>
                            setLeadDetails({
                              ...leadDetails,
                              [field.name]: e.value,
                            })
                          }
                        />
                      )}

                      {field.type === "file" && (
                        <input
                          type="file"
                          className="form-control"
                          onChange={(e) =>
                            setLeadDetails({
                              ...leadDetails,
                              [field.name]: e.target.files[0],
                            })
                          }
                        />
                      )}

                      <div className="text-danger">{errors[field.name]}</div>
                    </div>
                  );
                })}
              </div>

              {rowData?.lead?.id &&
                (!["ASSIGN_TO_OTHER", "DONE"].includes(rowData?.status) ?
                  <div className="row mb-1">

                    <div className="col-md-12">
                      <label htmlFor="status" className="form-label">
                        Status
                      </label>
                      <Dropdown
                        style={{ width: "100%" }}
                        options={userLeadStatus}
                        value={selectedUserLeadStatus}
                        onChange={(e) => {
                          setSelectedUserLeadStatus(e.value);
                        }}
                      />
                      <div className="text-danger">{errors.status}</div>
                    </div>
                  </div>
                  :
                  <div className="row mb-1">
                    <div className="col-md-12">
                      <label htmlFor="status" className="form-label">
                        Status
                      </label>
                      <Dropdown
                        style={{ width: "100%" }}
                        options={selectedAssignToOtherLeadStatus}
                      value={rowData?.status}
                        disabled
                      />
                      <div className="text-danger">{errors.status}</div>
                    </div>
                  </div>)}

              {!["ASSIGN_TO_OTHER", "DONE"].includes(rowData?.status) &&
                <div className="text-center">
                  <button type="submit" className="move-btn move-btn-blue">
                    Submit
                  </button>
                </div>}
            </form>
          </div>
        </div>
      </section>
      <div>{renderDialogLeadAssignmentUpload()}</div>
    </main>
  );
}